import React, { useState, useRef, useEffect } from "react"
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import DistVafCircularProgress from "./common/distVafCircularProgress";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReCAPTCHA from "react-google-recaptcha";
import { URL_API } from '../config/urls'
import { CAPTCHA_KEY } from "config/captcha"
import { handleDownload } from './DownloadFormularioWord'; 
import {validarCPF, validarCNPJ} from './util';
import { cnpj } from 'cpf-cnpj-validator';


export default function SolicitaAtualizacaoPrefeitura() {

	const isMounted = useRef(true);
    const [dados] = useState({});
	const [loader, setLoader]  = useState(false);
	const [codigoPrefeitura, setCodigoPrefeitura] = useState("");
	const [responsavel, setResponsavel]  = useState("");
	const [email, setEmail] = useState("");
	const [identificacao, setIdentificacao] = useState("");
	const [telefone, setTelefone] = useState("");
	const [file, setFile] = useState("");
	const txtCodigo = useRef("");
	const txtResponsavel = useRef("");
	const txtIdentificacao = useRef("");
	const txtEmail = useRef("");
	const txtFile = useRef("");
	const [captcha, setCaptcha] = useState(false);
	const [solicitacaoExistente, setSolicitacaoExistente] = useState(false);
	const [mostrarModalInformaSolicitacaoExistente, setMostrarModalInformaSolicitacaoExistente ] = useState(false);
	const [mostrarModalConfirmaEnvioSolicitacao, setMostrarModalConfirmaEnvioSolicitacao] = useState(false);

	useEffect(() => {
		isMounted.current = true;
	
		return () => {
		  isMounted.current = false;
		};
	  }, []);

	  

	function solicitarAtualizacao(e) {
		e.preventDefault(); // Evitar o comportamento padrão do formulário

		if(!codigoPrefeitura.trim().length){
			alert("O campo Prefeitura é obrigatório!")
			txtCodigo.current.focus()
			return false
		}
		if (!responsavel.trim().length) {
			alert("O campo Responsável é obrigatório!")
			txtResponsavel.current.focus()
			return false
		}

		//const fileUploaded = document.getElementById('file').files[0];
		const fileById = document.getElementById('file').files[0];

		//tratar fileById se undefined
			if (!fileById) {
				alert("O campo arquivo no formato PDF é obrigatório!")
				//txtFile.current.focus()
				return false
			}

		//verifica se file está vazio
		if (fileById && fileById.size === 0) {
			alert("O campo arquivo no formato PDF é obrigatório!")
			//txtFile.current.focus()
			return false
		}
		//verifica se arquivo é maior que 5MB
		if (fileById && fileById.size > 5242880) {
			alert("O arquivo deve ter no máximo 5MB!")
			txtFile.current.focus()
			return false
		}
		//verifica se file é um arquivo PDF
		if (fileById && !fileById.name.match(/\.pdf$/)) {
			alert("O arquivo deve estar no formato PDF!")
			txtFile.current.focus()
			return false
		}
		if (!email.trim().length) {
			alert("O campo email é obrigatório!")
			txtEmail.current.focus()
			return false
		}
		else if(!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)){
			alert("O campo email está num formato inválido.")
			txtEmail.current.focus()
			return false
		}


		if (!identificacao.trim().length) {
			alert("O campo CPF/CNPJ do responsável é obrigatório!")
			txtIdentificacao.current.focus()
			return false
		}
		const regexNumeros = /^\d+$/;
		if (!regexNumeros.test(identificacao) || (identificacao.length !== 11 && identificacao.length !== 14)) {
			alert("A identificação deve conter apenas números (retire pontos e traços) e ter 11 (CPF) ou 14 (CNPJ) caracteres!");
			txtIdentificacao.current.focus();
			return false;
		}
		if(identificacao.trim().length === 11 && !validarCPF(identificacao)) {
			alert("O CPF é inválido!");
			txtIdentificacao.current.focus();
			return false;
		}
		if( (identificacao.trim().length === 14 || identificacao.trim().length === 18) && !cnpj.isValid(identificacao)) {
			alert("O CNPJ é inválido!");
			txtIdentificacao.current.focus();
			return false;
		}

		if (!captcha) {
			alert("O campo captcha é obrigatório!")
			return false
		}

		if(solicitacaoExistente === false){
			setLoader(true);
			enviarArquivo(fileById);
		}
	}

	function enviarArquivo(fileById){

		let urlEnviarArquivo = `${URL_API}/api/v1/public/atualizaPrefeitura/enviarArquivo`
		const reader = new FileReader();
		reader.onloadend = function() {
			let fileUploaded = reader.result;
			let nmComprovante = gerarNomeArquivo(codigoPrefeitura, email);

			dados.codigoPrefeitura = codigoPrefeitura;
			dados.responsavel = responsavel;
			dados.email = email;
			dados.telefone = telefone;
			dados.fileUploaded = fileUploaded;
			dados.nmComprovante = nmComprovante;
			dados.identificacao = identificacao;

			const formData = new FormData();
			formData.append('fileUploaded', new Blob([fileUploaded], { type: 'application/pdf' }), nmComprovante);
			//formData.append('fileUploaded', fileUploaded);
			formData.append('dados', new Blob([JSON.stringify(dados)], { type: 'application/json' }));
			//String boundary = Long.toHexString(System.currentTimeMillis());
			let token_keycloack = sessionStorage.getItem('token_keycloack');

			const opcoes2 = {
				method: 'POST',
				body: formData,
				headers: { "Authorization": `Bearer ${token_keycloack}` }
			};

			fetch( urlEnviarArquivo, opcoes2)
				.then(res => res.text())
				.then(_res => {
					const retorno = JSON.parse(_res);
					const retornoTratado = JSON.parse(retorno[0]);
					if(retornoTratado[0].status === 'OK'){
						setMostrarModalConfirmaEnvioSolicitacao(true)
						limparCampos();
						window.scrollTo(0, 0)
					}else{
						//alert("Ocorreu um erro: "+retorno.trace);
						enviarEmailLog("codigoPrefeitura:"+codigoPrefeitura+" email:"+email+" Erro:"+retorno);
					}
					setLoader(false);
				})
				.catch(_err => {
					alert("Erro interno na aplicação." + _err)
					console.error("Erro interno na aplicação - " + _err)
					setLoader(false);
				});
		};

		reader.readAsArrayBuffer(fileById);
	}

	function enviarEmailLog(retorno){
		let urlEnviar = `${URL_API}/api/v1/public/email/enviarEmail`
		let token_keycloack = sessionStorage.getItem('token_keycloack');

		const opcoes = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${token_keycloack}` },
			body: "email="+ email+
			"&assunto=[DISTVAF - ERRO] - Erro ao solicitar atualização de prefeitura"+
			"&mensagem=Ocorreu um erro ao enviar o arquivo PDF."+retorno+
			"&destinatario=cristiane.candido@fazenda.mg.gov.br"
		};
		fetch( urlEnviar, opcoes)
			.then(res => res.text())
			.then(_res => {
				const retorno = JSON.parse(_res);

				if(retorno.status !== 'OK'){
					console.error("Erro ao enviar email de log - " + retorno.trace)
				}else{
					window.scrollTo(0, 0)
				}
				setLoader(false);
			})
			.catch(_err => {
				console.error("Erro ao enviar email de log - " + _err)
			});
	}

	function verificarSeExisteSolicitacaoSemAprovacao(codigoPrefeitura,event){

		event.preventDefault();

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		if(!token_keycloack){
			alert("Falha na comunicação com chave de segurança!");
		}

		let url = `${URL_API}/api/v1/public/atualizaPrefeitura/obterSolicitacaoNaoAprovadasPorCodigo/${codigoPrefeitura}`

		const opcoes = {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token_keycloack}` },
		};
		fetch(url,opcoes)
			.then(res => res.json())
			.then(res => {
				if (res.length > 0) {
					setLoader(false);
					setSolicitacaoExistente(true);
					setMostrarModalInformaSolicitacaoExistente(true);
				}
				return res;
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}

	function excluirSolicitacaoPendente(){

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		let url = `${URL_API}/api/v1/public/atualizaPrefeitura/excluirSolicitacao/${codigoPrefeitura}`

		const opcoes = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token_keycloack}` }
		};
		fetch(url,opcoes)
			.then(res => res.json())
			.then(res => {
				const retornoTratado = JSON.parse(res[0]);
				if (retornoTratado[0].status === 'OK') {
					setSolicitacaoExistente(false);
					setMostrarModalInformaSolicitacaoExistente(false);
				}
				else {
					alert("Erro ao excluir solicitação anterior para prefeitura: "+ codigoPrefeitura +" - "+ res.trace)
					console.error("Erro ao excluir solicitação anterior para prefeitura: "+ codigoPrefeitura +" - "+ res.trace)
					enviarEmailLog("Erro ao excluir solicitação anterior para prefeitura: "+ codigoPrefeitura +" - "+ res);
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}

	function gerarNomeArquivo( codigoPrefeitura, email) {
		let data = new Date();
		let mes = data.getMonth() + 1;
		let dia = data.getDate();
		if (mes < 10) mes = '0' + mes;
		if (dia < 10) dia = '0' + dia;
		let dataFormatada = data.getFullYear() + '' + mes + '' + dia;
		let segundos = data.getSeconds();

		return ( codigoPrefeitura +"_" + email +"_" + dataFormatada +"_"+ segundos +".pdf" );
	}

	function limparCampos(){
		setCodigoPrefeitura("");
		setResponsavel("");
		setEmail("");
		setTelefone("");
		setFile("");
		setIdentificacao("");
		window.grecaptcha.reset();
	}

	function validarToken(token){

		let url = `${URL_API}/api/v1/public/atualizaPrefeitura/autenticaRecaptcha`
		
		const opcoes = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			body: "projectID=pc-api-8831708888611922077-735"+
			"&recaptchaKey="+ CAPTCHA_KEY+
			"&token="+ token+
			"&secret=6Lc7Cx4qAAAAAFhPmAZZ7hhaPdZhiy0HRcMY_dJB"
		};
		fetch(url,opcoes)
			.then(res => res.json())
			.then(res => {
				const retorno = JSON.parse(res);
				if(retorno[0].status === 'OK'){
					sessionStorage.setItem('token_keycloack', retorno[0].trace);
					if (isMounted.current) {
						setCaptcha(true);
					}
				}
				else{
					if (isMounted.current) {
						setCaptcha(false);
						alert('Captcha inválido ou não resolvido.');
					}
				}
			})
			.catch(_err => {
				//alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
				//if (isMounted.current) {
				//	setCaptcha(false);
				//}
			});
		
	}

	function onChangeCaptcha(token) {

	  if (token) {
			setCaptcha(true);
			validarToken(token);
		} else {
			//alert("Captcha inválido ou não resolvido.");
			console.log("Captcha inválido ou expirado.");
		}
	}

	/*function onClickCaptcha(e) {
		e.preventDefault();
		const grecaptcha = window.grecaptcha;
		if (grecaptcha) {
			grecaptcha.enterprise.ready(async () => {
			const token = await grecaptcha.enterprise.execute('{CAPTCHA_KEY}', {action: 'LOGIN'});
			console.log("Token: "+token);
			});
		}
	  } */

	return (
		<div id="wrapper">
				<div id="main">
					<div className="inner ">
					<div className="container-fluid">
						<div className="row">
							<header className="main">
								<script src="https://www.google.com/recaptcha/api.js" async defer></script>
								<script src={`https://www.google.com/recaptcha/enterprise.js?render=${CAPTCHA_KEY}`}></script>
								<link rel="preconnect" href="https://fonts.googleapis.com" />
								<link rel="preconnect" href="https://fonts.gstatic.com" />
								<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap"/>

								<div className="container-fluid">
									<div className="row App-header">
										<a className="logo" ><img src="/distvaf/logo_fazenda_280_163.png" max-height="70%" width="auto"/></a>
									</div>
								</div>
							</header>
							<div className="col-12">
								<h2 style={{"marginTop": "-10px", "marginBottom": "-17px", "fontFamily": "Roboto, sans-serif"}}>Atualização de Prefeitura</h2>
								<form method='post' action='#'>
									{(loader && <DistVafCircularProgress />)}
									<div className="margem-antes">
										<table id="tblDados" className="stripe row-border">
											<thead>

											{!captcha && (
												<InputLabel color="error">
													Seja bem vindo! <br></br>
													Para prosseguir, clique em "Não sou um robô"
												</InputLabel>
											)}

											<ReCAPTCHA sitekey={CAPTCHA_KEY} onChange={onChangeCaptcha} hl="pt-BR" ti /><br></br>

											{
												captcha && (
												<Button onClick={handleDownload} variant="contained" color="error" style={{textDecoration: "underline", cursor: "pointer"} }>
												Baixe aqui o modelo do formulário de cadastramento de e-mail das prefeituras em arquivo Word para preenchimento e assinatura do Prefeito.
												</Button>
											 	)
											}
											<br></br><br></br> 


											{captcha && (
											<FormControl fullWidth margin="normal" >

												<InputLabel id="demo-simple-select-label">PREFEITURA: *</InputLabel>
												<Select
													labelId="demo-simple-select-label"
													id="codigoPrefeituraId"
													value={codigoPrefeitura}
													onChange={(e) => {setCodigoPrefeitura(e.target.value); verificarSeExisteSolicitacaoSemAprovacao(e.target.value, e); }}
													label="PREFEITURA: *"
													ref={txtCodigo}
													required
												>
													<MenuItem value={''}>Selecione sua prefeitura</MenuItem>
													<MenuItem value={'001'}>ABADIA DOS DOURADOS</MenuItem>
													<MenuItem value={'002'}>ABAETÉ</MenuItem>
													<MenuItem value={'003'}>ABRE CAMPO</MenuItem>
													<MenuItem value={'004'}>ACAIACA</MenuItem>
													<MenuItem value={'005'}>AÇUCENA</MenuItem>
													<MenuItem value={'006'}>ÁGUA BOA</MenuItem>
													<MenuItem value={'007'}>ÁGUA COMPRIDA</MenuItem>
													<MenuItem value={'008'}>AGUANIL</MenuItem>
													<MenuItem value={'009'}>ÁGUAS FORMOSAS</MenuItem>
													<MenuItem value={'010'}>ÁGUAS VERMELHAS</MenuItem>
													<MenuItem value={'011'}>AIMORÉS</MenuItem>
													<MenuItem value={'012'}>AIURUOCA</MenuItem>
													<MenuItem value={'013'}>ALAGOA</MenuItem>
													<MenuItem value={'014'}>ALBERTINA</MenuItem>
													<MenuItem value={'015'}>ALÉM PARAÍBA</MenuItem>
													<MenuItem value={'016'}>ALFENAS</MenuItem>
													<MenuItem value={'724'}>ALFREDO VASCONCELOS</MenuItem>
													<MenuItem value={'017'}>ALMENARA</MenuItem>
													<MenuItem value={'018'}>ALPERCATA</MenuItem>
													<MenuItem value={'019'}>ALPINÓPOLIS</MenuItem>
													<MenuItem value={'020'}>ALTEROSA</MenuItem>
													<MenuItem value={'769'}>ALTO CAPARAÓ</MenuItem>
													<MenuItem value={'535'}>ALTO JEQUITIBÁ</MenuItem>
													<MenuItem value={'021'}>ALTO RIO DOCE</MenuItem>
													<MenuItem value={'022'}>ALVARENGA</MenuItem>
													<MenuItem value={'023'}>ALVINÓPOLIS</MenuItem>
													<MenuItem value={'024'}>ALVORADA DE MINAS</MenuItem>
													<MenuItem value={'025'}>AMPARO DA SERRA</MenuItem>
													<MenuItem value={'026'}>ANDRADAS</MenuItem>
													<MenuItem value={'028'}>ANDRELÂNDIA</MenuItem>
													<MenuItem value={'770'}>ANGELÂNDIA</MenuItem>
													<MenuItem value={'029'}>ANTÔNIO CARLOS</MenuItem>
													<MenuItem value={'030'}>ANTÔNIO DIAS</MenuItem>
													<MenuItem value={'031'}>ANTÔNIO PRADO DE MINAS</MenuItem>
													<MenuItem value={'032'}>ARAÇAÍ</MenuItem>
													<MenuItem value={'033'}>ARACITABA</MenuItem>
													<MenuItem value={'034'}>ARAÇUAÍ</MenuItem>
													<MenuItem value={'035'}>ARAGUARI</MenuItem>
													<MenuItem value={'036'}>ARANTINA</MenuItem>
													<MenuItem value={'037'}>ARAPONGA</MenuItem>
													<MenuItem value={'725'}>ARAPORÃ</MenuItem>
													<MenuItem value={'038'}>ARAPUÁ</MenuItem>
													<MenuItem value={'039'}>ARAÚJOS</MenuItem>
													<MenuItem value={'040'}>ARAXÁ</MenuItem>
													<MenuItem value={'041'}>ARCEBURGO</MenuItem>
													<MenuItem value={'042'}>ARCOS</MenuItem>
													<MenuItem value={'043'}>AREADO</MenuItem>
													<MenuItem value={'044'}>ARGIRITA</MenuItem>
													<MenuItem value={'771'}>ARICANDUVA</MenuItem>
													<MenuItem value={'045'}>ARINOS</MenuItem>
													<MenuItem value={'046'}>ASTOLFO DUTRA</MenuItem>
													<MenuItem value={'047'}>ATALÉIA</MenuItem>
													<MenuItem value={'048'}>AUGUSTO DE LIMA</MenuItem>
													<MenuItem value={'049'}>BAEPENDI</MenuItem>
													<MenuItem value={'050'}>BALDIM</MenuItem>
													<MenuItem value={'051'}>BAMBUÍ</MenuItem>
													<MenuItem value={'052'}>BANDEIRA</MenuItem>
													<MenuItem value={'053'}>BANDEIRA DO SUL</MenuItem>
													<MenuItem value={'054'}>BARÃO DE COCAIS</MenuItem>
													<MenuItem value={'055'}>BARÃO DE MONTE ALTO</MenuItem>
													<MenuItem value={'056'}>BARBACENA</MenuItem>
													<MenuItem value={'057'}>BARRA LONGA</MenuItem>
													<MenuItem value={'059'}>BARROSO</MenuItem>
													<MenuItem value={'060'}>BELA VISTA DE MINAS</MenuItem>
													<MenuItem value={'061'}>BELMIRO BRAGA</MenuItem>
													<MenuItem value={'062'}>BELO HORIZONTE</MenuItem>
													<MenuItem value={'063'}>BELO ORIENTE</MenuItem>
													<MenuItem value={'064'}>BELO VALE</MenuItem>
													<MenuItem value={'065'}>BERILO</MenuItem>
													<MenuItem value={'772'}>BERIZAL</MenuItem>
													<MenuItem value={'066'}>BERTÓPOLIS</MenuItem>
													<MenuItem value={'067'}>BETIM</MenuItem>
													<MenuItem value={'068'}>BIAS FORTES</MenuItem>
													<MenuItem value={'069'}>BICAS</MenuItem>
													<MenuItem value={'070'}>BIQUINHAS</MenuItem>
													<MenuItem value={'071'}>BOA ESPERANÇA</MenuItem>
													<MenuItem value={'072'}>BOCAINA DE MINAS</MenuItem>
													<MenuItem value={'073'}>BOCAIUVA</MenuItem>
													<MenuItem value={'074'}>BOM DESPACHO</MenuItem>
													<MenuItem value={'075'}>BOM JARDIM DE MINAS</MenuItem>
													<MenuItem value={'076'}>BOM JESUS DA PENHA</MenuItem>
													<MenuItem value={'077'}>BOM JESUS DO AMPARO</MenuItem>
													<MenuItem value={'078'}>BOM JESUS DO GALHO</MenuItem>
													<MenuItem value={'079'}>BOM REPOUSO</MenuItem>
													<MenuItem value={'080'}>BOM SUCESSO</MenuItem>
													<MenuItem value={'081'}>BONFIM</MenuItem>
													<MenuItem value={'082'}>BONFINÓPOLIS DE MINAS</MenuItem>
													<MenuItem value={'773'}>BONITO DE MINAS</MenuItem>
													<MenuItem value={'083'}>BORDA DA MATA</MenuItem>
													<MenuItem value={'084'}>BOTELHOS</MenuItem>
													<MenuItem value={'085'}>BOTUMIRIM</MenuItem>
													<MenuItem value={'087'}>BRÁS PIRES</MenuItem>
													<MenuItem value={'774'}>BRASILÂNDIA DE MINAS</MenuItem>
													<MenuItem value={'086'}>BRASÍLIA DE MINAS</MenuItem>
													<MenuItem value={'089'}>BRAÚNAS</MenuItem>
													<MenuItem value={'088'}>BRAZÓPOLIS</MenuItem>
													<MenuItem value={'090'}>BRUMADINHO</MenuItem>
													<MenuItem value={'091'}>BUENO BRANDÃO</MenuItem>
													<MenuItem value={'092'}>BUENÓPOLIS</MenuItem>
													<MenuItem value={'775'}>BUGRE</MenuItem>
													<MenuItem value={'093'}>BURITIS</MenuItem>
													<MenuItem value={'094'}>BURITIZEIRO</MenuItem>
													<MenuItem value={'776'}>CABECEIRA GRANDE</MenuItem>
													<MenuItem value={'095'}>CABO VERDE</MenuItem>
													<MenuItem value={'096'}>CACHOEIRA DA PRATA</MenuItem>
													<MenuItem value={'097'}>CACHOEIRA DE MINAS</MenuItem>
													<MenuItem value={'027'}>CACHOEIRA DE PAJEÚ</MenuItem>
													<MenuItem value={'098'}>CACHOEIRA DOURADA</MenuItem>
													<MenuItem value={'099'}>CAETANÓPOLIS</MenuItem>
													<MenuItem value={'100'}>CAETÉ</MenuItem>
													<MenuItem value={'101'}>CAIANA</MenuItem>
													<MenuItem value={'102'}>CAJURI</MenuItem>
													<MenuItem value={'103'}>CALDAS</MenuItem>
													<MenuItem value={'104'}>CAMACHO</MenuItem>
													<MenuItem value={'105'}>CAMANDUCAIA</MenuItem>
													<MenuItem value={'106'}>CAMBUÍ</MenuItem>
													<MenuItem value={'107'}>CAMBUQUIRA</MenuItem>
													<MenuItem value={'108'}>CAMPANÁRIO</MenuItem>
													<MenuItem value={'109'}>CAMPANHA</MenuItem>
													<MenuItem value={'110'}>CAMPESTRE</MenuItem>
													<MenuItem value={'111'}>CAMPINA VERDE</MenuItem>
													<MenuItem value={'777'}>CAMPO AZUL</MenuItem>
													<MenuItem value={'112'}>CAMPO BELO</MenuItem>
													<MenuItem value={'113'}>CAMPO DO MEIO</MenuItem>
													<MenuItem value={'114'}>CAMPO FLORIDO</MenuItem>
													<MenuItem value={'115'}>CAMPOS ALTOS</MenuItem>
													<MenuItem value={'116'}>CAMPOS GERAIS</MenuItem>
													<MenuItem value={'119'}>CANA VERDE</MenuItem>
													<MenuItem value={'117'}>CANAÃ</MenuItem>
													<MenuItem value={'118'}>CANÁPOLIS</MenuItem>
													<MenuItem value={'120'}>CANDEIAS</MenuItem>
													<MenuItem value={'778'}>CANTAGALO</MenuItem>
													<MenuItem value={'121'}>CAPARAÓ</MenuItem>
													<MenuItem value={'122'}>CAPELA NOVA</MenuItem>
													<MenuItem value={'123'}>CAPELINHA</MenuItem>
													<MenuItem value={'124'}>CAPETINGA</MenuItem>
													<MenuItem value={'125'}>CAPIM BRANCO</MenuItem>
													<MenuItem value={'126'}>CAPINÓPOLIS</MenuItem>
													<MenuItem value={'727'}>CAPITÃO ANDRADE</MenuItem>
													<MenuItem value={'127'}>CAPITÃO ENÉAS</MenuItem>
													<MenuItem value={'128'}>CAPITÓLIO</MenuItem>
													<MenuItem value={'129'}>CAPUTIRA</MenuItem>
													<MenuItem value={'130'}>CARAÍ</MenuItem>
													<MenuItem value={'131'}>CARANAÍBA</MenuItem>
													<MenuItem value={'132'}>CARANDAÍ</MenuItem>
													<MenuItem value={'133'}>CARANGOLA</MenuItem>
													<MenuItem value={'134'}>CARATINGA</MenuItem>
													<MenuItem value={'135'}>CARBONITA</MenuItem>
													<MenuItem value={'136'}>CAREAÇU</MenuItem>
													<MenuItem value={'137'}>CARLOS CHAGAS</MenuItem>
													<MenuItem value={'138'}>CARMÉSIA</MenuItem>
													<MenuItem value={'139'}>CARMO DA CACHOEIRA</MenuItem>
													<MenuItem value={'140'}>CARMO DA MATA</MenuItem>
													<MenuItem value={'141'}>CARMO DE MINAS</MenuItem>
													<MenuItem value={'142'}>CARMO DO CAJURU</MenuItem>
													<MenuItem value={'143'}>CARMO DO PARANAÍBA</MenuItem>
													<MenuItem value={'144'}>CARMO DO RIO CLARO</MenuItem>
													<MenuItem value={'145'}>CARMÓPOLIS DE MINAS</MenuItem>
													<MenuItem value={'728'}>CARNEIRINHO</MenuItem>
													<MenuItem value={'146'}>CARRANCAS</MenuItem>
													<MenuItem value={'147'}>CARVALHÓPOLIS</MenuItem>
													<MenuItem value={'148'}>CARVALHOS</MenuItem>
													<MenuItem value={'149'}>CASA GRANDE</MenuItem>
													<MenuItem value={'150'}>CASCALHO RICO</MenuItem>
													<MenuItem value={'151'}>CÁSSIA</MenuItem>
													<MenuItem value={'153'}>CATAGUASES</MenuItem>
													<MenuItem value={'154'}>CATAS ALTAS</MenuItem>
													<MenuItem value={'779'}>CATAS ALTAS DA NORUEGA</MenuItem>
													<MenuItem value={'729'}>CATUJI</MenuItem>
													<MenuItem value={'780'}>CATUTI</MenuItem>
													<MenuItem value={'155'}>CAXAMBU</MenuItem>
													<MenuItem value={'156'}>CEDRO DO ABAETÉ</MenuItem>
													<MenuItem value={'157'}>CENTRAL DE MINAS</MenuItem>
													<MenuItem value={'158'}>CENTRALINA</MenuItem>
													<MenuItem value={'159'}>CHÁCARA</MenuItem>
													<MenuItem value={'160'}>CHALÉ</MenuItem>
													<MenuItem value={'161'}>CHAPADA DO NORTE</MenuItem>
													<MenuItem value={'781'}>CHAPADA GAÚCHA</MenuItem>
													<MenuItem value={'162'}>CHIADOR</MenuItem>
													<MenuItem value={'163'}>CIPOTÂNEA</MenuItem>
													<MenuItem value={'164'}>CLARAVAL</MenuItem>
													<MenuItem value={'165'}>CLARO DOS POÇÕES</MenuItem>
													<MenuItem value={'166'}>CLÁUDIO</MenuItem>
													<MenuItem value={'167'}>COIMBRA</MenuItem>
													<MenuItem value={'168'}>COLUNA</MenuItem>
													<MenuItem value={'169'}>COMENDADOR GOMES</MenuItem>
													<MenuItem value={'170'}>COMERCINHO</MenuItem>
													<MenuItem value={'171'}>CONCEIÇÃO DA APARECIDA</MenuItem>
													<MenuItem value={'152'}>CONCEIÇÃO DA BARRA DE MINAS</MenuItem>
													<MenuItem value={'172'}>CONCEIÇÃO DAS ALAGOAS</MenuItem>
													<MenuItem value={'173'}>CONCEIÇÃO DAS PEDRAS</MenuItem>
													<MenuItem value={'174'}>CONCEIÇÃO DE IPANEMA</MenuItem>
													<MenuItem value={'175'}>CONCEIÇÃO DO MATO DENTRO</MenuItem>
													<MenuItem value={'176'}>CONCEIÇÃO DO PARÁ</MenuItem>
													<MenuItem value={'177'}>CONCEIÇÃO DO RIO VERDE</MenuItem>
													<MenuItem value={'178'}>CONCEIÇÃO DOS OUROS</MenuItem>
													<MenuItem value={'782'}>CÔNEGO MARINHO</MenuItem>
													<MenuItem value={'783'}>CONFINS</MenuItem>
													<MenuItem value={'179'}>CONGONHAL</MenuItem>
													<MenuItem value={'181'}>CONGONHAS</MenuItem>
													<MenuItem value={'180'}>CONGONHAS DO NORTE</MenuItem>
													<MenuItem value={'182'}>CONQUISTA</MenuItem>
													<MenuItem value={'183'}>CONSELHEIRO LAFAIETE</MenuItem>
													<MenuItem value={'184'}>CONSELHEIRO PENA</MenuItem>
													<MenuItem value={'185'}>CONSOLAÇÃO</MenuItem>
													<MenuItem value={'186'}>CONTAGEM</MenuItem>
													<MenuItem value={'187'}>COQUEIRAL</MenuItem>
													<MenuItem value={'188'}>CORAÇÃO DE JESUS</MenuItem>
													<MenuItem value={'189'}>CORDISBURGO</MenuItem>
													<MenuItem value={'190'}>CORDISLÂNDIA</MenuItem>
													<MenuItem value={'191'}>CORINTO</MenuItem>
													<MenuItem value={'192'}>COROACI</MenuItem>
													<MenuItem value={'193'}>COROMANDEL</MenuItem>
													<MenuItem value={'194'}>CORONEL FABRICIANO</MenuItem>
													<MenuItem value={'195'}>CORONEL MURTA</MenuItem>
													<MenuItem value={'196'}>CORONEL PACHECO</MenuItem>
													<MenuItem value={'197'}>CORONEL XAVIER CHAVES</MenuItem>
													<MenuItem value={'198'}>CÓRREGO DANTA</MenuItem>
													<MenuItem value={'199'}>CÓRREGO DO BOM JESUS</MenuItem>
													<MenuItem value={'784'}>CÓRREGO FUNDO</MenuItem>
													<MenuItem value={'200'}>CÓRREGO NOVO</MenuItem>
													<MenuItem value={'201'}>COUTO DE MAGALHÃES DE MINAS</MenuItem>
													<MenuItem value={'785'}>CRISÓLITA</MenuItem>
													<MenuItem value={'202'}>CRISTAIS</MenuItem>
													<MenuItem value={'203'}>CRISTÁLIA</MenuItem>
													<MenuItem value={'204'}>CRISTIANO OTONI</MenuItem>
													<MenuItem value={'205'}>CRISTINA</MenuItem>
													<MenuItem value={'206'}>CRUCILÂNDIA</MenuItem>
													<MenuItem value={'207'}>CRUZEIRO DA FORTALEZA</MenuItem>
													<MenuItem value={'208'}>CRUZÍLIA</MenuItem>
													<MenuItem value={'786'}>CUPARAQUE</MenuItem>
													<MenuItem value={'787'}>CURRAL DE DENTRO</MenuItem>
													<MenuItem value={'209'}>CURVELO</MenuItem>
													<MenuItem value={'210'}>DATAS</MenuItem>
													<MenuItem value={'211'}>DELFIM MOREIRA</MenuItem>
													<MenuItem value={'212'}>DELFINÓPOLIS</MenuItem>
													<MenuItem value={'864'}>DELTA</MenuItem>
													<MenuItem value={'213'}>DESCOBERTO</MenuItem>
													<MenuItem value={'214'}>DESTERRO DE ENTRE RIOS</MenuItem>
													<MenuItem value={'215'}>DESTERRO DO MELO</MenuItem>
													<MenuItem value={'216'}>DIAMANTINA</MenuItem>
													<MenuItem value={'217'}>DIOGO DE VASCONCELOS</MenuItem>
													<MenuItem value={'218'}>DIONÍSIO</MenuItem>
													<MenuItem value={'219'}>DIVINÉSIA</MenuItem>
													<MenuItem value={'220'}>DIVINO</MenuItem>
													<MenuItem value={'221'}>DIVINO DAS LARANJEIRAS</MenuItem>
													<MenuItem value={'222'}>DIVINOLÂNDIA DE MINAS</MenuItem>
													<MenuItem value={'223'}>DIVINÓPOLIS</MenuItem>
													<MenuItem value={'788'}>DIVISA ALEGRE</MenuItem>
													<MenuItem value={'224'}>DIVISA NOVA</MenuItem>
													<MenuItem value={'731'}>DIVISÓPOLIS</MenuItem>
													<MenuItem value={'789'}>DOM BOSCO</MenuItem>
													<MenuItem value={'225'}>DOM CAVATI</MenuItem>
													<MenuItem value={'226'}>DOM JOAQUIM</MenuItem>
													<MenuItem value={'227'}>DOM SILVÉRIO</MenuItem>
													<MenuItem value={'228'}>DOM VIÇOSO</MenuItem>
													<MenuItem value={'229'}>DONA EUZÉBIA</MenuItem>
													<MenuItem value={'230'}>DORES DE CAMPOS</MenuItem>
													<MenuItem value={'231'}>DORES DE GUANHÃES</MenuItem>
													<MenuItem value={'232'}>DORES DO INDAIÁ</MenuItem>
													<MenuItem value={'233'}>DORES DO TURVO</MenuItem>
													<MenuItem value={'234'}>DORESÓPOLIS</MenuItem>
													<MenuItem value={'235'}>DOURADOQUARA</MenuItem>
													<MenuItem value={'732'}>DURANDÉ</MenuItem>
													<MenuItem value={'236'}>ELÓI MENDES</MenuItem>
													<MenuItem value={'237'}>ENGENHEIRO CALDAS</MenuItem>
													<MenuItem value={'238'}>ENGENHEIRO NAVARRO</MenuItem>
													<MenuItem value={'239'}>ENTRE FOLHAS</MenuItem>
													<MenuItem value={'733'}>ENTRE RIOS DE MINAS</MenuItem>
													<MenuItem value={'240'}>ERVÁLIA</MenuItem>
													<MenuItem value={'241'}>ESMERALDAS</MenuItem>
													<MenuItem value={'242'}>ESPERA FELIZ</MenuItem>
													<MenuItem value={'243'}>ESPINOSA</MenuItem>
													<MenuItem value={'244'}>ESPÍRITO SANTO DO DOURADO</MenuItem>
													<MenuItem value={'245'}>ESTIVA</MenuItem>
													<MenuItem value={'246'}>ESTRELA DALVA</MenuItem>
													<MenuItem value={'247'}>ESTRELA DO INDAIÁ</MenuItem>
													<MenuItem value={'248'}>ESTRELA DO SUL</MenuItem>
													<MenuItem value={'249'}>EUGENÓPOLIS</MenuItem>
													<MenuItem value={'250'}>EWBANK DA CÂMARA</MenuItem>
													<MenuItem value={'251'}>EXTREMA</MenuItem>
													<MenuItem value={'252'}>FAMA</MenuItem>
													<MenuItem value={'253'}>FARIA LEMOS</MenuItem>
													<MenuItem value={'254'}>FELÍCIO DOS SANTOS</MenuItem>
													<MenuItem value={'256'}>FELISBURGO</MenuItem>
													<MenuItem value={'257'}>FELIXLÂNDIA</MenuItem>
													<MenuItem value={'258'}>FERNANDES TOURINHO</MenuItem>
													<MenuItem value={'259'}>FERROS</MenuItem>
													<MenuItem value={'734'}>FERVEDOURO</MenuItem>
													<MenuItem value={'260'}>FLORESTAL</MenuItem>
													<MenuItem value={'261'}>FORMIGA</MenuItem>
													<MenuItem value={'262'}>FORMOSO</MenuItem>
													<MenuItem value={'263'}>FORTALEZA DE MINAS</MenuItem>
													<MenuItem value={'264'}>FORTUNA DE MINAS</MenuItem>
													<MenuItem value={'265'}>FRANCISCO BADARÓ</MenuItem>
													<MenuItem value={'266'}>FRANCISCO DUMONT</MenuItem>
													<MenuItem value={'267'}>FRANCISCO SÁ</MenuItem>
													<MenuItem value={'790'}>FRANCISCÓPOLIS</MenuItem>
													<MenuItem value={'268'}>FREI GASPAR</MenuItem>
													<MenuItem value={'269'}>FREI INOCÊNCIO</MenuItem>
													<MenuItem value={'791'}>FREI LAGONEGRO</MenuItem>
													<MenuItem value={'270'}>FRONTEIRA</MenuItem>
													<MenuItem value={'468'}>FRONTEIRA DOS VALES</MenuItem>
													<MenuItem value={'792'}>FRUTA DE LEITE</MenuItem>
													<MenuItem value={'271'}>FRUTAL</MenuItem>
													<MenuItem value={'272'}>FUNILÂNDIA</MenuItem>
													<MenuItem value={'273'}>GALILEIA</MenuItem>
													<MenuItem value={'793'}>GAMELEIRAS</MenuItem>
													<MenuItem value={'794'}>GLAUCILÂNDIA</MenuItem>
													<MenuItem value={'795'}>GOIABEIRA</MenuItem>
													<MenuItem value={'796'}>GOIANÁ</MenuItem>
													<MenuItem value={'274'}>GONÇALVES</MenuItem>
													<MenuItem value={'275'}>GONZAGA</MenuItem>
													<MenuItem value={'276'}>GOUVEIA</MenuItem>
													<MenuItem value={'277'}>GOVERNADOR VALADARES</MenuItem>
													<MenuItem value={'278'}>GRÃO MOGOL</MenuItem>
													<MenuItem value={'279'}>GRUPIARA</MenuItem>
													<MenuItem value={'280'}>GUANHÃES</MenuItem>
													<MenuItem value={'281'}>GUAPÉ</MenuItem>
													<MenuItem value={'282'}>GUARACIABA</MenuItem>
													<MenuItem value={'797'}>GUARACIAMA</MenuItem>
													<MenuItem value={'283'}>GUARANÉSIA</MenuItem>
													<MenuItem value={'284'}>GUARANI</MenuItem>
													<MenuItem value={'285'}>GUARARÁ</MenuItem>
													<MenuItem value={'286'}>GUARDA-MOR</MenuItem>
													<MenuItem value={'287'}>GUAXUPÉ</MenuItem>
													<MenuItem value={'288'}>GUIDOVAL</MenuItem>
													<MenuItem value={'289'}>GUIMARÂNIA</MenuItem>
													<MenuItem value={'290'}>GUIRICEMA</MenuItem>
													<MenuItem value={'291'}>GURINHATÃ</MenuItem>
													<MenuItem value={'292'}>HELIODORA</MenuItem>
													<MenuItem value={'293'}>IAPU</MenuItem>
													<MenuItem value={'294'}>IBERTIOGA</MenuItem>
													<MenuItem value={'295'}>IBIÁ</MenuItem>
													<MenuItem value={'296'}>IBIAÍ</MenuItem>
													<MenuItem value={'798'}>IBIRACATU</MenuItem>
													<MenuItem value={'297'}>IBIRACI</MenuItem>
													<MenuItem value={'298'}>IBIRITÉ</MenuItem>
													<MenuItem value={'299'}>IBITIÚRA DE MINAS</MenuItem>
													<MenuItem value={'300'}>IBITURUNA</MenuItem>
													<MenuItem value={'736'}>ICARAÍ DE MINAS</MenuItem>
													<MenuItem value={'301'}>IGARAPÉ</MenuItem>
													<MenuItem value={'302'}>IGARATINGA</MenuItem>
													<MenuItem value={'303'}>IGUATAMA</MenuItem>
													<MenuItem value={'304'}>IJACI</MenuItem>
													<MenuItem value={'305'}>ILICÍNEA</MenuItem>
													<MenuItem value={'799'}>IMBÉ DE MINAS</MenuItem>
													<MenuItem value={'306'}>INCONFIDENTES</MenuItem>
													<MenuItem value={'800'}>INDAIABIRA</MenuItem>
													<MenuItem value={'307'}>INDIANÓPOLIS</MenuItem>
													<MenuItem value={'308'}>INGAÍ</MenuItem>
													<MenuItem value={'309'}>INHAPIM</MenuItem>
													<MenuItem value={'310'}>INHAÚMA</MenuItem>
													<MenuItem value={'311'}>INIMUTABA</MenuItem>
													<MenuItem value={'737'}>IPABA</MenuItem>
													<MenuItem value={'312'}>IPANEMA</MenuItem>
													<MenuItem value={'313'}>IPATINGA</MenuItem>
													<MenuItem value={'314'}>IPIAÇU</MenuItem>
													<MenuItem value={'315'}>IPUIUNA</MenuItem>
													<MenuItem value={'316'}>IRAÍ DE MINAS</MenuItem>
													<MenuItem value={'317'}>ITABIRA</MenuItem>
													<MenuItem value={'318'}>ITABIRINHA</MenuItem>
													<MenuItem value={'319'}>ITABIRITO</MenuItem>
													<MenuItem value={'320'}>ITACAMBIRA</MenuItem>
													<MenuItem value={'321'}>ITACARAMBI</MenuItem>
													<MenuItem value={'322'}>ITAGUARA</MenuItem>
													<MenuItem value={'323'}>ITAIPÉ</MenuItem>
													<MenuItem value={'324'}>ITAJUBÁ</MenuItem>
													<MenuItem value={'325'}>ITAMARANDIBA</MenuItem>
													<MenuItem value={'326'}>ITAMARATI DE MINAS</MenuItem>
													<MenuItem value={'327'}>ITAMBACURI</MenuItem>
													<MenuItem value={'328'}>ITAMBÉ DO MATO DENTRO</MenuItem>
													<MenuItem value={'329'}>ITAMOGI</MenuItem>
													<MenuItem value={'330'}>ITAMONTE</MenuItem>
													<MenuItem value={'331'}>ITANHANDU</MenuItem>
													<MenuItem value={'332'}>ITANHOMI</MenuItem>
													<MenuItem value={'333'}>ITAOBIM</MenuItem>
													<MenuItem value={'334'}>ITAPAGIPE</MenuItem>
													<MenuItem value={'335'}>ITAPECERICA</MenuItem>
													<MenuItem value={'336'}>ITAPEVA</MenuItem>
													<MenuItem value={'337'}>ITATIAIUÇU</MenuItem>
													<MenuItem value={'723'}>ITAÚ DE MINAS</MenuItem>
													<MenuItem value={'338'}>ITAÚNA</MenuItem>
													<MenuItem value={'339'}>ITAVERAVA</MenuItem>
													<MenuItem value={'340'}>ITINGA</MenuItem>
													<MenuItem value={'341'}>ITUETA</MenuItem>
													<MenuItem value={'342'}>ITUIUTABA</MenuItem>
													<MenuItem value={'343'}>ITUMIRIM</MenuItem>
													<MenuItem value={'344'}>ITURAMA</MenuItem>
													<MenuItem value={'345'}>ITUTINGA</MenuItem>
													<MenuItem value={'346'}>JABOTICATUBAS</MenuItem>
													<MenuItem value={'347'}>JACINTO</MenuItem>
													<MenuItem value={'348'}>JACUÍ</MenuItem>
													<MenuItem value={'349'}>JACUTINGA</MenuItem>
													<MenuItem value={'350'}>JAGUARAÇU</MenuItem>
													<MenuItem value={'738'}>JAÍBA</MenuItem>
													<MenuItem value={'739'}>JAMPRUCA</MenuItem>
													<MenuItem value={'351'}>JANAÚBA</MenuItem>
													<MenuItem value={'352'}>JANUÁRIA</MenuItem>
													<MenuItem value={'353'}>JAPARAÍBA</MenuItem>
													<MenuItem value={'865'}>JAPONVAR</MenuItem>
													<MenuItem value={'354'}>JECEABA</MenuItem>
													<MenuItem value={'801'}>JENIPAPO DE MINAS</MenuItem>
													<MenuItem value={'355'}>JEQUERI</MenuItem>
													<MenuItem value={'356'}>JEQUITAÍ</MenuItem>
													<MenuItem value={'357'}>JEQUITIBÁ</MenuItem>
													<MenuItem value={'358'}>JEQUITINHONHA</MenuItem>
													<MenuItem value={'359'}>JESUÂNIA</MenuItem>
													<MenuItem value={'360'}>JOAÍMA</MenuItem>
													<MenuItem value={'361'}>JOANÉSIA</MenuItem>
													<MenuItem value={'362'}>JOÃO MONLEVADE</MenuItem>
													<MenuItem value={'363'}>JOÃO PINHEIRO</MenuItem>
													<MenuItem value={'364'}>JOAQUIM FELÍCIO</MenuItem>
													<MenuItem value={'365'}>JORDÂNIA</MenuItem>
													<MenuItem value={'802'}>JOSÉ GONÇALVES DE MINAS</MenuItem>
													<MenuItem value={'803'}>JOSÉ RAYDAN</MenuItem>
													<MenuItem value={'804'}>JOSENÓPOLIS</MenuItem>
													<MenuItem value={'740'}>JUATUBA</MenuItem>
													<MenuItem value={'367'}>JUIZ DE FORA</MenuItem>
													<MenuItem value={'368'}>JURAMENTO</MenuItem>
													<MenuItem value={'369'}>JURUAIA</MenuItem>
													<MenuItem value={'805'}>JUVENÍLIA</MenuItem>
													<MenuItem value={'370'}>LADAINHA</MenuItem>
													<MenuItem value={'371'}>LAGAMAR</MenuItem>
													<MenuItem value={'372'}>LAGOA DA PRATA</MenuItem>
													<MenuItem value={'373'}>LAGOA DOS PATOS</MenuItem>
													<MenuItem value={'374'}>LAGOA DOURADA</MenuItem>
													<MenuItem value={'375'}>LAGOA FORMOSA</MenuItem>
													<MenuItem value={'741'}>LAGOA GRANDE</MenuItem>
													<MenuItem value={'376'}>LAGOA SANTA</MenuItem>
													<MenuItem value={'377'}>LAJINHA</MenuItem>
													<MenuItem value={'378'}>LAMBARI</MenuItem>
													<MenuItem value={'379'}>LAMIM</MenuItem>
													<MenuItem value={'380'}>LARANJAL</MenuItem>
													<MenuItem value={'381'}>LASSANCE</MenuItem>
													<MenuItem value={'382'}>LAVRAS</MenuItem>
													<MenuItem value={'383'}>LEANDRO FERREIRA</MenuItem>
													<MenuItem value={'806'}>LEME DO PRADO</MenuItem>
													<MenuItem value={'384'}>LEOPOLDINA</MenuItem>
													<MenuItem value={'385'}>LIBERDADE</MenuItem>
													<MenuItem value={'386'}>LIMA DUARTE</MenuItem>
													<MenuItem value={'742'}>LIMEIRA DO OESTE</MenuItem>
													<MenuItem value={'743'}>LONTRA</MenuItem>
													<MenuItem value={'807'}>LUISBURGO</MenuItem>
													<MenuItem value={'808'}>LUISLÂNDIA</MenuItem>
													<MenuItem value={'387'}>LUMINÁRIAS</MenuItem>
													<MenuItem value={'388'}>LUZ</MenuItem>
													<MenuItem value={'389'}>MACHACALIS</MenuItem>
													<MenuItem value={'390'}>MACHADO</MenuItem>
													<MenuItem value={'391'}>MADRE DE DEUS DE MINAS</MenuItem>
													<MenuItem value={'392'}>MALACACHETA</MenuItem>
													<MenuItem value={'744'}>MAMONAS</MenuItem>
													<MenuItem value={'393'}>MANGA</MenuItem>
													<MenuItem value={'394'}>MANHUAÇU</MenuItem>
													<MenuItem value={'395'}>MANHUMIRIM</MenuItem>
													<MenuItem value={'396'}>MANTENA</MenuItem>
													<MenuItem value={'398'}>MAR DE ESPANHA</MenuItem>
													<MenuItem value={'397'}>MARAVILHAS</MenuItem>
													<MenuItem value={'399'}>MARIA DA FÉ</MenuItem>
													<MenuItem value={'400'}>MARIANA</MenuItem>
													<MenuItem value={'401'}>MARILAC</MenuItem>
													<MenuItem value={'809'}>MÁRIO CAMPOS</MenuItem>
													<MenuItem value={'402'}>MARIPÁ DE MINAS</MenuItem>
													<MenuItem value={'403'}>MARLIÉRIA</MenuItem>
													<MenuItem value={'404'}>MARMELÓPOLIS</MenuItem>
													<MenuItem value={'405'}>MARTINHO CAMPOS</MenuItem>
													<MenuItem value={'810'}>MARTINS SOARES</MenuItem>
													<MenuItem value={'745'}>MATA VERDE</MenuItem>
													<MenuItem value={'406'}>MATERLÂNDIA</MenuItem>
													<MenuItem value={'407'}>MATEUS LEME</MenuItem>
													<MenuItem value={'715'}>MATHIAS LOBATO</MenuItem>
													<MenuItem value={'408'}>MATIAS BARBOSA</MenuItem>
													<MenuItem value={'746'}>MATIAS CARDOSO</MenuItem>
													<MenuItem value={'409'}>MATIPÓ</MenuItem>
													<MenuItem value={'410'}>MATO VERDE</MenuItem>
													<MenuItem value={'411'}>MATOZINHOS</MenuItem>
													<MenuItem value={'412'}>MATUTINA</MenuItem>
													<MenuItem value={'413'}>MEDEIROS</MenuItem>
													<MenuItem value={'414'}>MEDINA</MenuItem>
													<MenuItem value={'415'}>MENDES PIMENTEL</MenuItem>
													<MenuItem value={'416'}>MERCÊS</MenuItem>
													<MenuItem value={'417'}>MESQUITA</MenuItem>
													<MenuItem value={'418'}>MINAS NOVAS</MenuItem>
													<MenuItem value={'419'}>MINDURI</MenuItem>
													<MenuItem value={'420'}>MIRABELA</MenuItem>
													<MenuItem value={'421'}>MIRADOURO</MenuItem>
													<MenuItem value={'422'}>MIRAÍ</MenuItem>
													<MenuItem value={'811'}>MIRAVÂNIA</MenuItem>
													<MenuItem value={'423'}>MOEDA</MenuItem>
													<MenuItem value={'424'}>MOEMA</MenuItem>
													<MenuItem value={'425'}>MONJOLOS</MenuItem>
													<MenuItem value={'426'}>MONSENHOR PAULO</MenuItem>
													<MenuItem value={'427'}>MONTALVÂNIA</MenuItem>
													<MenuItem value={'428'}>MONTE ALEGRE DE MINAS</MenuItem>
													<MenuItem value={'429'}>MONTE AZUL</MenuItem>
													<MenuItem value={'430'}>MONTE BELO</MenuItem>
													<MenuItem value={'431'}>MONTE CARMELO</MenuItem>
													<MenuItem value={'812'}>MONTE FORMOSO</MenuItem>
													<MenuItem value={'432'}>MONTE SANTO DE MINAS</MenuItem>
													<MenuItem value={'434'}>MONTE SIÃO</MenuItem>
													<MenuItem value={'433'}>MONTES CLAROS</MenuItem>
													<MenuItem value={'747'}>MONTEZUMA</MenuItem>
													<MenuItem value={'435'}>MORADA NOVA DE MINAS</MenuItem>
													<MenuItem value={'436'}>MORRO DA GARÇA</MenuItem>
													<MenuItem value={'437'}>MORRO DO PILAR</MenuItem>
													<MenuItem value={'438'}>MUNHOZ</MenuItem>
													<MenuItem value={'439'}>MURIAÉ</MenuItem>
													<MenuItem value={'440'}>MUTUM</MenuItem>
													<MenuItem value={'441'}>MUZAMBINHO</MenuItem>
													<MenuItem value={'442'}>NACIP RAYDAN</MenuItem>
													<MenuItem value={'443'}>NANUQUE</MenuItem>
													<MenuItem value={'813'}>NAQUE</MenuItem>
													<MenuItem value={'814'}>NATALÂNDIA</MenuItem>
													<MenuItem value={'444'}>NATÉRCIA</MenuItem>
													<MenuItem value={'445'}>NAZARENO</MenuItem>
													<MenuItem value={'446'}>NEPOMUCENO</MenuItem>
													<MenuItem value={'815'}>NINHEIRA</MenuItem>
													<MenuItem value={'816'}>NOVA BELÉM</MenuItem>
													<MenuItem value={'447'}>NOVA ERA</MenuItem>
													<MenuItem value={'448'}>NOVA LIMA</MenuItem>
													<MenuItem value={'449'}>NOVA MÓDICA</MenuItem>
													<MenuItem value={'450'}>NOVA PONTE</MenuItem>
													<MenuItem value={'817'}>NOVA PORTEIRINHA</MenuItem>
													<MenuItem value={'451'}>NOVA RESENDE</MenuItem>
													<MenuItem value={'452'}>NOVA SERRANA</MenuItem>
													<MenuItem value={'366'}>NOVA UNIÃO</MenuItem>
													<MenuItem value={'453'}>NOVO CRUZEIRO</MenuItem>
													<MenuItem value={'818'}>NOVO ORIENTE DE MINAS</MenuItem>
													<MenuItem value={'819'}>NOVORIZONTE</MenuItem>
													<MenuItem value={'454'}>OLARIA</MenuItem>
													<MenuItem value={'820'}>OLHOS D ÁGUA</MenuItem>
													<MenuItem value={'455'}>OLÍMPIO NORONHA</MenuItem>
													<MenuItem value={'456'}>OLIVEIRA</MenuItem>
													<MenuItem value={'457'}>OLIVEIRA FORTES</MenuItem>
													<MenuItem value={'458'}>ONÇA DE PITANGUI</MenuItem>
													<MenuItem value={'821'}>ORATÓRIOS</MenuItem>
													<MenuItem value={'822'}>ORIZÂNIA</MenuItem>
													<MenuItem value={'459'}>OURO BRANCO</MenuItem>
													<MenuItem value={'460'}>OURO FINO</MenuItem>
													<MenuItem value={'461'}>OURO PRETO</MenuItem>
													<MenuItem value={'462'}>OURO VERDE DE MINAS</MenuItem>
													<MenuItem value={'823'}>PADRE CARVALHO</MenuItem>
													<MenuItem value={'463'}>PADRE PARAÍSO</MenuItem>
													<MenuItem value={'824'}>PAI PEDRO</MenuItem>
													<MenuItem value={'464'}>PAINEIRAS</MenuItem>
													<MenuItem value={'465'}>PAINS</MenuItem>
													<MenuItem value={'466'}>PAIVA</MenuItem>
													<MenuItem value={'467'}>PALMA</MenuItem>
													<MenuItem value={'750'}>PALMÓPOLIS</MenuItem>
													<MenuItem value={'469'}>PAPAGAIOS</MenuItem>
													<MenuItem value={'471'}>PARÁ DE MINAS</MenuItem>
													<MenuItem value={'470'}>PARACATU</MenuItem>
													<MenuItem value={'472'}>PARAGUAÇU</MenuItem>
													<MenuItem value={'473'}>PARAISÓPOLIS</MenuItem>
													<MenuItem value={'474'}>PARAOPEBA</MenuItem>
													<MenuItem value={'476'}>PASSA QUATRO</MenuItem>
													<MenuItem value={'477'}>PASSA TEMPO</MenuItem>
													<MenuItem value={'478'}>PASSA VINTE</MenuItem>
													<MenuItem value={'475'}>PASSABÉM</MenuItem>
													<MenuItem value={'479'}>PASSOS</MenuItem>
													<MenuItem value={'825'}>PATIS</MenuItem>
													<MenuItem value={'480'}>PATOS DE MINAS</MenuItem>
													<MenuItem value={'482'}>PATROCÍNIO</MenuItem>
													<MenuItem value={'481'}>PATROCÍNIO DO MURIAÉ</MenuItem>
													<MenuItem value={'483'}>PAULA CÂNDIDO</MenuItem>
													<MenuItem value={'484'}>PAULISTAS</MenuItem>
													<MenuItem value={'485'}>PAVÃO</MenuItem>
													<MenuItem value={'486'}>PEÇANHA</MenuItem>
													<MenuItem value={'487'}>PEDRA AZUL</MenuItem>
													<MenuItem value={'826'}>PEDRA BONITA</MenuItem>
													<MenuItem value={'488'}>PEDRA DO ANTA</MenuItem>
													<MenuItem value={'489'}>PEDRA DO INDAIÁ</MenuItem>
													<MenuItem value={'490'}>PEDRA DOURADA</MenuItem>
													<MenuItem value={'491'}>PEDRALVA</MenuItem>
													<MenuItem value={'751'}>PEDRAS DE MARIA DA CRUZ</MenuItem>
													<MenuItem value={'492'}>PEDRINÓPOLIS</MenuItem>
													<MenuItem value={'493'}>PEDRO LEOPOLDO</MenuItem>
													<MenuItem value={'494'}>PEDRO TEIXEIRA</MenuItem>
													<MenuItem value={'495'}>PEQUERI</MenuItem>
													<MenuItem value={'496'}>PEQUI</MenuItem>
													<MenuItem value={'497'}>PERDIGÃO</MenuItem>
													<MenuItem value={'498'}>PERDIZES</MenuItem>
													<MenuItem value={'499'}>PERDÕES</MenuItem>
													<MenuItem value={'827'}>PERIQUITO</MenuItem>
													<MenuItem value={'500'}>PESCADOR</MenuItem>
													<MenuItem value={'501'}>PIAU</MenuItem>
													<MenuItem value={'828'}>PIEDADE DE CARATINGA</MenuItem>
													<MenuItem value={'502'}>PIEDADE DE PONTE NOVA</MenuItem>
													<MenuItem value={'503'}>PIEDADE DO RIO GRANDE</MenuItem>
													<MenuItem value={'504'}>PIEDADE DOS GERAIS</MenuItem>
													<MenuItem value={'505'}>PIMENTA</MenuItem>
													<MenuItem value={'829'}>PINGO D ÁGUA</MenuItem>
													<MenuItem value={'830'}>PINTÓPOLIS</MenuItem>
													<MenuItem value={'506'}>PIRACEMA</MenuItem>
													<MenuItem value={'507'}>PIRAJUBA</MenuItem>
													<MenuItem value={'508'}>PIRANGA</MenuItem>
													<MenuItem value={'509'}>PIRANGUÇU</MenuItem>
													<MenuItem value={'510'}>PIRANGUINHO</MenuItem>
													<MenuItem value={'511'}>PIRAPETINGA</MenuItem>
													<MenuItem value={'512'}>PIRAPORA</MenuItem>
													<MenuItem value={'513'}>PIRAÚBA</MenuItem>
													<MenuItem value={'514'}>PITANGUI</MenuItem>
													<MenuItem value={'515'}>PIUMHI</MenuItem>
													<MenuItem value={'516'}>PLANURA</MenuItem>
													<MenuItem value={'517'}>POÇO FUNDO</MenuItem>
													<MenuItem value={'518'}>POÇOS DE CALDAS</MenuItem>
													<MenuItem value={'519'}>POCRANE</MenuItem>
													<MenuItem value={'520'}>POMPÉU</MenuItem>
													<MenuItem value={'521'}>PONTE NOVA</MenuItem>
													<MenuItem value={'831'}>PONTO CHIQUE</MenuItem>
													<MenuItem value={'832'}>PONTO DOS VOLANTES</MenuItem>
													<MenuItem value={'522'}>PORTEIRINHA</MenuItem>
													<MenuItem value={'523'}>PORTO FIRME</MenuItem>
													<MenuItem value={'524'}>POTÉ</MenuItem>
													<MenuItem value={'525'}>POUSO ALEGRE</MenuItem>
													<MenuItem value={'526'}>POUSO ALTO</MenuItem>
													<MenuItem value={'527'}>PRADOS</MenuItem>
													<MenuItem value={'528'}>PRATA</MenuItem>
													<MenuItem value={'529'}>PRATÁPOLIS</MenuItem>
													<MenuItem value={'530'}>PRATINHA</MenuItem>
													<MenuItem value={'531'}>PRESIDENTE BERNARDES</MenuItem>
													<MenuItem value={'532'}>PRESIDENTE JUSCELINO</MenuItem>
													<MenuItem value={'533'}>PRESIDENTE KUBITSCHEK</MenuItem>
													<MenuItem value={'534'}>PRESIDENTE OLEGÁRIO</MenuItem>
													<MenuItem value={'536'}>PRUDENTE DE MORAIS</MenuItem>
													<MenuItem value={'537'}>QUARTEL GERAL</MenuItem>
													<MenuItem value={'538'}>QUELUZITO</MenuItem>
													<MenuItem value={'539'}>RAPOSOS</MenuItem>
													<MenuItem value={'540'}>RAUL SOARES</MenuItem>
													<MenuItem value={'541'}>RECREIO</MenuItem>
													<MenuItem value={'833'}>REDUTO</MenuItem>
													<MenuItem value={'542'}>RESENDE COSTA</MenuItem>
													<MenuItem value={'543'}>RESPLENDOR</MenuItem>
													<MenuItem value={'544'}>RESSAQUINHA</MenuItem>
													<MenuItem value={'754'}>RIACHINHO</MenuItem>
													<MenuItem value={'545'}>RIACHO DOS MACHADOS</MenuItem>
													<MenuItem value={'546'}>RIBEIRÃO DAS NEVES</MenuItem>
													<MenuItem value={'547'}>RIBEIRÃO VERMELHO</MenuItem>
													<MenuItem value={'548'}>RIO ACIMA</MenuItem>
													<MenuItem value={'549'}>RIO CASCA</MenuItem>
													<MenuItem value={'551'}>RIO DO PRADO</MenuItem>
													<MenuItem value={'550'}>RIO DOCE</MenuItem>
													<MenuItem value={'552'}>RIO ESPERA</MenuItem>
													<MenuItem value={'553'}>RIO MANSO</MenuItem>
													<MenuItem value={'554'}>RIO NOVO</MenuItem>
													<MenuItem value={'555'}>RIO PARANAÍBA</MenuItem>
													<MenuItem value={'556'}>RIO PARDO DE MINAS</MenuItem>
													<MenuItem value={'557'}>RIO PIRACICABA</MenuItem>
													<MenuItem value={'558'}>RIO POMBA</MenuItem>
													<MenuItem value={'559'}>RIO PRETO</MenuItem>
													<MenuItem value={'560'}>RIO VERMELHO</MenuItem>
													<MenuItem value={'561'}>RITÁPOLIS</MenuItem>
													<MenuItem value={'562'}>ROCHEDO DE MINAS</MenuItem>
													<MenuItem value={'563'}>RODEIRO</MenuItem>
													<MenuItem value={'564'}>ROMARIA</MenuItem>
													<MenuItem value={'834'}>ROSÁRIO DA LIMEIRA</MenuItem>
													<MenuItem value={'565'}>RUBELITA</MenuItem>
													<MenuItem value={'566'}>RUBIM</MenuItem>
													<MenuItem value={'567'}>SABARÁ</MenuItem>
													<MenuItem value={'568'}>SABINÓPOLIS</MenuItem>
													<MenuItem value={'569'}>SACRAMENTO</MenuItem>
													<MenuItem value={'570'}>SALINAS</MenuItem>
													<MenuItem value={'571'}>SALTO DA DIVISA</MenuItem>
													<MenuItem value={'572'}>SANTA BÁRBARA</MenuItem>
													<MenuItem value={'756'}>SANTA BÁRBARA DO LESTE</MenuItem>
													<MenuItem value={'835'}>SANTA BÁRBARA DO MONTE VERDE</MenuItem>
													<MenuItem value={'573'}>SANTA BÁRBARA DO TUGÚRIO</MenuItem>
													<MenuItem value={'836'}>SANTA CRUZ DE MINAS</MenuItem>
													<MenuItem value={'837'}>SANTA CRUZ DE SALINAS</MenuItem>
													<MenuItem value={'574'}>SANTA CRUZ DO ESCALVADO</MenuItem>
													<MenuItem value={'575'}>SANTA EFIGÊNIA DE MINAS</MenuItem>
													<MenuItem value={'576'}>SANTA FÉ DE MINAS</MenuItem>
													<MenuItem value={'838'}>SANTA HELENA DE MINAS</MenuItem>
													<MenuItem value={'577'}>SANTA JULIANA</MenuItem>
													<MenuItem value={'578'}>SANTA LUZIA</MenuItem>
													<MenuItem value={'579'}>SANTA MARGARIDA</MenuItem>
													<MenuItem value={'580'}>SANTA MARIA DE ITABIRA</MenuItem>
													<MenuItem value={'581'}>SANTA MARIA DO SALTO</MenuItem>
													<MenuItem value={'582'}>SANTA MARIA DO SUAÇUÍ</MenuItem>
													<MenuItem value={'592'}>SANTA RITA DE CALDAS</MenuItem>
													<MenuItem value={'593'}>SANTA RITA DE IBITIPOCA</MenuItem>
													<MenuItem value={'595'}>SANTA RITA DE JACUTINGA</MenuItem>
													<MenuItem value={'757'}>SANTA RITA DE MINAS</MenuItem>
													<MenuItem value={'594'}>SANTA RITA DO ITUETO</MenuItem>
													<MenuItem value={'596'}>SANTA RITA DO SAPUCAÍ</MenuItem>
													<MenuItem value={'597'}>SANTA ROSA DA SERRA</MenuItem>
													<MenuItem value={'598'}>SANTA VITÓRIA</MenuItem>
													<MenuItem value={'583'}>SANTANA DA VARGEM</MenuItem>
													<MenuItem value={'584'}>SANTANA DE CATAGUASES</MenuItem>
													<MenuItem value={'585'}>SANTANA DE PIRAPAMA</MenuItem>
													<MenuItem value={'586'}>SANTANA DO DESERTO</MenuItem>
													<MenuItem value={'587'}>SANTANA DO GARAMBÉU</MenuItem>
													<MenuItem value={'588'}>SANTANA DO JACARÉ</MenuItem>
													<MenuItem value={'589'}>SANTANA DO MANHUAÇU</MenuItem>
													<MenuItem value={'758'}>SANTANA DO PARAÍSO</MenuItem>
													<MenuItem value={'590'}>SANTANA DO RIACHO</MenuItem>
													<MenuItem value={'591'}>SANTANA DOS MONTES</MenuItem>
													<MenuItem value={'599'}>SANTO ANTÔNIO DO AMPARO</MenuItem>
													<MenuItem value={'600'}>SANTO ANTÔNIO DO AVENTUREIRO</MenuItem>
													<MenuItem value={'601'}>SANTO ANTÔNIO DO GRAMA</MenuItem>
													<MenuItem value={'602'}>SANTO ANTÔNIO DO ITAMBÉ</MenuItem>
													<MenuItem value={'603'}>SANTO ANTÔNIO DO JACINTO</MenuItem>
													<MenuItem value={'604'}>SANTO ANTÔNIO DO MONTE</MenuItem>
													<MenuItem value={'839'}>SANTO ANTÔNIO DO RETIRO</MenuItem>
													<MenuItem value={'605'}>SANTO ANTÔNIO DO RIO ABAIXO</MenuItem>
													<MenuItem value={'606'}>SANTO HIPÓLITO</MenuItem>
													<MenuItem value={'607'}>SANTOS DUMONT</MenuItem>
													<MenuItem value={'608'}>SÃO BENTO ABADE</MenuItem>
													<MenuItem value={'609'}>SÃO BRÁS DO SUAÇUÍ</MenuItem>
													<MenuItem value={'840'}>SÃO DOMINGOS DAS DORES</MenuItem>
													<MenuItem value={'610'}>SÃO DOMINGOS DO PRATA</MenuItem>
													<MenuItem value={'841'}>SÃO FÉLIX DE MINAS</MenuItem>
													<MenuItem value={'611'}>SÃO FRANCISCO</MenuItem>
													<MenuItem value={'612'}>SÃO FRANCISCO DE PAULA</MenuItem>
													<MenuItem value={'613'}>SÃO FRANCISCO DE SALES</MenuItem>
													<MenuItem value={'614'}>SÃO FRANCISCO DO GLÓRIA</MenuItem>
													<MenuItem value={'615'}>SÃO GERALDO</MenuItem>
													<MenuItem value={'616'}>SÃO GERALDO DA PIEDADE</MenuItem>
													<MenuItem value={'842'}>SÃO GERALDO DO BAIXIO</MenuItem>
													<MenuItem value={'617'}>SÃO GONÇALO DO ABAETÉ</MenuItem>
													<MenuItem value={'618'}>SÃO GONÇALO DO PARÁ</MenuItem>
													<MenuItem value={'619'}>SÃO GONÇALO DO RIO ABAIXO</MenuItem>
													<MenuItem value={'255'}>SÃO GONÇALO DO RIO PRETO</MenuItem>
													<MenuItem value={'620'}>SÃO GONÇALO DO SAPUCAÍ</MenuItem>
													<MenuItem value={'621'}>SÃO GOTARDO</MenuItem>
													<MenuItem value={'622'}>SÃO JOÃO BATISTA DO GLÓRIA</MenuItem>
													<MenuItem value={'843'}>SÃO JOÃO DA LAGOA</MenuItem>
													<MenuItem value={'623'}>SÃO JOÃO DA MATA</MenuItem>
													<MenuItem value={'624'}>SÃO JOÃO DA PONTE</MenuItem>
													<MenuItem value={'844'}>SÃO JOÃO DAS MISSÕES</MenuItem>
													<MenuItem value={'625'}>SÃO JOÃO DEL-REI</MenuItem>
													<MenuItem value={'760'}>SÃO JOÃO DO MANHUAÇU</MenuItem>
													<MenuItem value={'761'}>SÃO JOÃO DO MANTENINHA</MenuItem>
													<MenuItem value={'626'}>SÃO JOÃO DO ORIENTE</MenuItem>
													<MenuItem value={'845'}>SÃO JOÃO DO PACUÍ</MenuItem>
													<MenuItem value={'627'}>SÃO JOÃO DO PARAÍSO</MenuItem>
													<MenuItem value={'628'}>SÃO JOÃO EVANGELISTA</MenuItem>
													<MenuItem value={'629'}>SÃO JOÃO NEPOMUCENO</MenuItem>
													<MenuItem value={'846'}>SÃO JOAQUIM DE BICAS</MenuItem>
													<MenuItem value={'847'}>SÃO JOSÉ DA BARRA</MenuItem>
													<MenuItem value={'763'}>SÃO JOSÉ DA LAPA</MenuItem>
													<MenuItem value={'630'}>SÃO JOSÉ DA SAFIRA</MenuItem>
													<MenuItem value={'631'}>SÃO JOSÉ DA VARGINHA</MenuItem>
													<MenuItem value={'632'}>SÃO JOSÉ DO ALEGRE</MenuItem>
													<MenuItem value={'633'}>SÃO JOSÉ DO DIVINO</MenuItem>
													<MenuItem value={'634'}>SÃO JOSÉ DO GOIABAL</MenuItem>
													<MenuItem value={'635'}>SÃO JOSÉ DO JACURI</MenuItem>
													<MenuItem value={'636'}>SÃO JOSÉ DO MANTIMENTO</MenuItem>
													<MenuItem value={'637'}>SÃO LOURENÇO</MenuItem>
													<MenuItem value={'638'}>SÃO MIGUEL DO ANTA</MenuItem>
													<MenuItem value={'639'}>SÃO PEDRO DA UNIÃO</MenuItem>
													<MenuItem value={'640'}>SÃO PEDRO DO SUAÇUÍ</MenuItem>
													<MenuItem value={'641'}>SÃO PEDRO DOS FERROS</MenuItem>
													<MenuItem value={'642'}>SÃO ROMÃO</MenuItem>
													<MenuItem value={'643'}>SÃO ROQUE DE MINAS</MenuItem>
													<MenuItem value={'644'}>SÃO SEBASTIÃO DA BELA VISTA</MenuItem>
													<MenuItem value={'848'}>SÃO SEBASTIÃO DA VARGEM ALEGRE</MenuItem>
													<MenuItem value={'849'}>SÃO SEBASTIÃO DO ANTA</MenuItem>
													<MenuItem value={'645'}>SÃO SEBASTIÃO DO MARANHÃO</MenuItem>
													<MenuItem value={'646'}>SÃO SEBASTIÃO DO OESTE</MenuItem>
													<MenuItem value={'647'}>SÃO SEBASTIÃO DO PARAÍSO</MenuItem>
													<MenuItem value={'648'}>SÃO SEBASTIÃO DO RIO PRETO</MenuItem>
													<MenuItem value={'649'}>SÃO SEBASTIÃO DO RIO VERDE</MenuItem>
													<MenuItem value={'650'}>SÃO TIAGO</MenuItem>
													<MenuItem value={'651'}>SÃO TOMÁS DE AQUINO</MenuItem>
													<MenuItem value={'652'}>SÃO TOMÉ DAS LETRAS</MenuItem>
													<MenuItem value={'653'}>SÃO VICENTE DE MINAS</MenuItem>
													<MenuItem value={'654'}>SAPUCAÍ-MIRIM</MenuItem>
													<MenuItem value={'655'}>SARDOÁ</MenuItem>
													<MenuItem value={'850'}>SARZEDO</MenuItem>
													<MenuItem value={'851'}>SEM-PEIXE</MenuItem>
													<MenuItem value={'766'}>SENADOR AMARAL</MenuItem>
													<MenuItem value={'656'}>SENADOR CORTES</MenuItem>
													<MenuItem value={'657'}>SENADOR FIRMINO</MenuItem>
													<MenuItem value={'658'}>SENADOR JOSÉ BENTO</MenuItem>
													<MenuItem value={'659'}>SENADOR MODESTINO GONÇALVES</MenuItem>
													<MenuItem value={'660'}>SENHORA DE OLIVEIRA</MenuItem>
													<MenuItem value={'661'}>SENHORA DO PORTO</MenuItem>
													<MenuItem value={'662'}>SENHORA DOS REMÉDIOS</MenuItem>
													<MenuItem value={'663'}>SERICITA</MenuItem>
													<MenuItem value={'664'}>SERITINGA</MenuItem>
													<MenuItem value={'665'}>SERRA AZUL DE MINAS</MenuItem>
													<MenuItem value={'666'}>SERRA DA SAUDADE</MenuItem>
													<MenuItem value={'667'}>SERRA DO SALITRE</MenuItem>
													<MenuItem value={'668'}>SERRA DOS AIMORÉS</MenuItem>
													<MenuItem value={'669'}>SERRANIA</MenuItem>
													<MenuItem value={'852'}>SERRANÓPOLIS DE MINAS</MenuItem>
													<MenuItem value={'670'}>SERRANOS</MenuItem>
													<MenuItem value={'671'}>SERRO</MenuItem>
													<MenuItem value={'672'}>SETE LAGOAS</MenuItem>
													<MenuItem value={'853'}>SETUBINHA</MenuItem>
													<MenuItem value={'673'}>SILVEIRÂNIA</MenuItem>
													<MenuItem value={'674'}>SILVIANÓPOLIS</MenuItem>
													<MenuItem value={'675'}>SIMÃO PEREIRA</MenuItem>
													<MenuItem value={'676'}>SIMONÉSIA</MenuItem>
													<MenuItem value={'677'}>SOBRÁLIA</MenuItem>
													<MenuItem value={'678'}>SOLEDADE DE MINAS</MenuItem>
													<MenuItem value={'679'}>TABULEIRO</MenuItem>
													<MenuItem value={'680'}>TAIOBEIRAS</MenuItem>
													<MenuItem value={'854'}>TAPARUBA</MenuItem>
													<MenuItem value={'681'}>TAPIRA</MenuItem>
													<MenuItem value={'682'}>TAPIRAÍ</MenuItem>
													<MenuItem value={'683'}>TAQUARAÇU DE MINAS</MenuItem>
													<MenuItem value={'684'}>TARUMIRIM</MenuItem>
													<MenuItem value={'685'}>TEIXEIRAS</MenuItem>
													<MenuItem value={'686'}>TEÓFILO OTONI</MenuItem>
													<MenuItem value={'687'}>TIMÓTEO</MenuItem>
													<MenuItem value={'688'}>TIRADENTES</MenuItem>
													<MenuItem value={'689'}>TIROS</MenuItem>
													<MenuItem value={'690'}>TOCANTINS</MenuItem>
													<MenuItem value={'855'}>TOCOS DO MOJI</MenuItem>
													<MenuItem value={'691'}>TOLEDO</MenuItem>
													<MenuItem value={'692'}>TOMBOS</MenuItem>
													<MenuItem value={'693'}>TRÊS CORAÇÕES</MenuItem>
													<MenuItem value={'058'}>TRÊS MARIAS</MenuItem>
													<MenuItem value={'694'}>TRÊS PONTAS</MenuItem>
													<MenuItem value={'695'}>TUMIRITINGA</MenuItem>
													<MenuItem value={'696'}>TUPACIGUARA</MenuItem>
													<MenuItem value={'697'}>TURMALINA</MenuItem>
													<MenuItem value={'698'}>TURVOLÂNDIA</MenuItem>
													<MenuItem value={'699'}>UBÁ</MenuItem>
													<MenuItem value={'700'}>UBAÍ</MenuItem>
													<MenuItem value={'767'}>UBAPORANGA</MenuItem>
													<MenuItem value={'701'}>UBERABA</MenuItem>
													<MenuItem value={'702'}>UBERLÂNDIA</MenuItem>
													<MenuItem value={'703'}>UMBURATIBA</MenuItem>
													<MenuItem value={'704'}>UNAÍ</MenuItem>
													<MenuItem value={'856'}>UNIÃO DE MINAS</MenuItem>
													<MenuItem value={'857'}>URUANA DE MINAS</MenuItem>
													<MenuItem value={'705'}>URUCÂNIA</MenuItem>
													<MenuItem value={'768'}>URUCUIA</MenuItem>
													<MenuItem value={'858'}>VARGEM ALEGRE</MenuItem>
													<MenuItem value={'706'}>VARGEM BONITA</MenuItem>
													<MenuItem value={'859'}>VARGEM GRANDE DO RIO PARDO</MenuItem>
													<MenuItem value={'707'}>VARGINHA</MenuItem>
													<MenuItem value={'860'}>VARJÃO DE MINAS</MenuItem>
													<MenuItem value={'708'}>VÁRZEA DA PALMA</MenuItem>
													<MenuItem value={'709'}>VARZELÂNDIA</MenuItem>
													<MenuItem value={'710'}>VAZANTE</MenuItem>
													<MenuItem value={'861'}>VERDELÂNDIA</MenuItem>
													<MenuItem value={'862'}>VEREDINHA</MenuItem>
													<MenuItem value={'711'}>VERÍSSIMO</MenuItem>
													<MenuItem value={'863'}>VERMELHO NOVO</MenuItem>
													<MenuItem value={'712'}>VESPASIANO</MenuItem>
													<MenuItem value={'713'}>VIÇOSA</MenuItem>
													<MenuItem value={'714'}>VIEIRAS</MenuItem>
													<MenuItem value={'716'}>VIRGEM DA LAPA</MenuItem>
													<MenuItem value={'717'}>VIRGÍNIA</MenuItem>
													<MenuItem value={'718'}>VIRGINÓPOLIS</MenuItem>
													<MenuItem value={'719'}>VIRGOLÂNDIA</MenuItem>
													<MenuItem value={'720'}>VISCONDE DO RIO BRANCO</MenuItem>
													<MenuItem value={'721'}>VOLTA GRANDE</MenuItem>
													<MenuItem value={'722'}>WENCESLAU BRAZ</MenuItem>
												</Select><br></br>
												
												<TextField id="responsavelId"   label="RESPONSÁVEL PELO VAF: " 			required    variant="outlined" value={responsavel} 		onChange={(e) => setResponsavel(e.target.value)} ref={txtResponsavel}/><br></br>
												<TextField id="responsavelId"   label="CPF/CNPJ RESPONSÁVEL PELO VAF (somente números): " required    variant="outlined" value={identificacao} 	onChange={(e) => setIdentificacao(e.target.value)} ref={txtIdentificacao} inputProps={{ maxLength: 14 }}/><br></br>
												<TextField id="telefoneId"      label="TELEFONE: "             			required    variant="outlined" value={telefone} 		onChange={(e) => setTelefone(e.target.value)} inputProps={{ maxLength: 19 }} /><br></br>
												<TextField id="emailId"         label="EMAIL: "                			required    variant="outlined" value={email} 			onChange={(e) => setEmail(e.target.value)} ref={txtEmail} inputProps={{ maxLength: 50 }}/><br></br>
												<TextField id="file"         	label="Carregar arquivo PDF com assinatura do prefeito (somente pdf e tamanho máximo de 5MB)"                required    variant="outlined" value={file} 	type="file"	onChange={(e) => setFile(e.target.value)} ref={txtFile} accept="application/pdf" InputLabelProps={{shrink: true,}}/><br></br>

												<Button variant="contained" color="primary" onClick={ (e) => solicitarAtualizacao(e)}>Enviar dados para atualização</Button>
												
											</FormControl>

											)}

											<footer id="footer" style={{"margin-top":"0px"}}>
												<div className="inner App-footer-slin">
													<p>Rodovia Papa João Paulo II, 4.001 - Prédio
										Gerais (6º e 7º andares) - Bairro Serra Verde, Belo Horizonte/MG CEP 31630-901</p>
												</div>
											</footer>
											</thead>
										</table>
									</div>
								</form>
							</div>
							{				
								<Dialog open={mostrarModalConfirmaEnvioSolicitacao} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
									<DialogTitle id="alert-dialog-title">Atenção</DialogTitle>
									<DialogContent>
										<DialogContentText id="alert-dialog-description">
											Solicitação enviada com sucesso! <br></br> Após conferência dos dados, você será notificado via email.
										</DialogContentText>
									</DialogContent>
									<DialogActions>
										<Button variant="contained" color="primary" onClick={ () => setMostrarModalConfirmaEnvioSolicitacao(false)}>Ciente</Button>
									</DialogActions>
								</Dialog> 
							}
							{
								<Dialog open={mostrarModalInformaSolicitacaoExistente} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
								<DialogTitle id="alert-dialog-title">Atenção</DialogTitle>
								<DialogContent>
									<DialogContentText id="alert-dialog-description">
										Já existe uma solicitação de atualização para essa prefeitura. <br></br>Deseja excluir a solicitação anterior e criar uma nova?
									</DialogContentText>
								</DialogContent>
								<DialogActions>
									<Button variant="contained" color="primary" onClick={ () =>{excluirSolicitacaoPendente(); setMostrarModalInformaSolicitacaoExistente(false)}}>Criar nova solicitação</Button>
									<Button variant="contained" color="primary" onClick={ () =>{setCodigoPrefeitura(''); setMostrarModalInformaSolicitacaoExistente(false)}}>Cancelar</Button>
								</DialogActions>
								</Dialog> 
							}
						</div>
					</div>

					
					</div>
					
				</div>
				
			</div>
	)
}
